import React from "react";

class IconMicrophone extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width}
        height={this.props.height}
        fill="none"
        viewBox="0 0 32 32"
      >
        <path
          fill="#fff"
          d="M10.637 16.768c.01.513.063.956.168 1.36.599 2.266 2.794 3.823 5.189 3.823.367 0 .745-.04 1.113-.118 2.521-.522 4.223-2.522 4.244-4.966.01-2.512.02-5.498 0-8.542-.021-1.921-.925-3.41-2.69-4.404-.808-.473-1.732-.66-2.909-.65a5.14 5.14 0 00-2.878.916c-1.47 1.005-2.227 2.414-2.237 4.177-.01.976-.01 1.96 0 2.936v2.444c-.01 1.005-.01 2.01 0 3.024zm8.592.04c.042 1.567-1.166 2.907-2.805 3.113-1.701.207-3.287-.857-3.613-2.433a2.828 2.828 0 01-.052-.512v-2.07c0-2.256-.011-4.512.01-6.768 0-.779.357-1.508.977-2.07a3.302 3.302 0 012.206-.837h.126c1.806.069 3.13 1.36 3.15 3.104V13.87c-.01.986-.02 1.961 0 2.937z"
        ></path>
        <path
          fill="#fff"
          d="M24.054 15.94c-.504-.089-1.019.168-1.187.61a1.492 1.492 0 00-.095.553 5.762 5.762 0 01-1.102 3.28c-1.198 1.685-2.889 2.65-5.032 2.858-1.355.138-2.636-.099-3.813-.71-1.733-.886-2.857-2.197-3.35-3.911-.116-.414-.168-.838-.221-1.29-.021-.168-.042-.355-.063-.543-.053-.364-.273-.64-.63-.788a1.12 1.12 0 00-.988.079 1.057 1.057 0 00-.483.916c.032 1.557.462 2.986 1.303 4.267 1.103 1.674 2.636 2.847 4.558 3.487.484.168.998.276 1.481.385.158.039.326.069.484.108v1.507h-2.49c-.157 0-.367.01-.567.07a.96.96 0 00-.662 1.093c.084.473.525.808 1.061.808h7.426c.336 0 .641-.118.851-.335a.949.949 0 00.252-.778c-.063-.523-.514-.858-1.155-.868h-2.574v-1.527l.347-.059c.4-.069.777-.138 1.155-.256 2.658-.788 4.56-2.404 5.662-4.798.441-.966.662-2 .683-3.183 0-.463-.357-.877-.851-.975z"
        ></path>
      </svg>
    );
  }
}

IconMicrophone.defaultProps = {
    width: 22,
    height: 22
}

export default IconMicrophone;
